import * as React from "react";

export function TasksPage(): JSX.Element {
  return (
    <div className="p-6">
      <h1 className="text-xl font-medium mb-2">Tasks</h1>
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <p className="text-sm text-blue-700 mb-2">🚧 Feature in Development</p>
        <p className="text-sm text-blue-600">Task management functionality is coming soon. This page will allow you to create and track cooking tasks, meal prep schedules, and shopping lists.</p>
      </div>
    </div>
  );
}

